import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "奉行クラウドAPI連携", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-info" }, [
  /*#__PURE__*/_createElementVNode("span", null, "奉行クラウドのログイン画面が表示されます。")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dismissible_alert = _resolveComponent("dismissible-alert")!
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, null, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _hoisted_2,
      _createVNode(_component_dismissible_alert, {
        class: "mt-3",
        color: "danger",
        message: _ctx.requestError,
        onDismiss: _cache[0] || (_cache[0] = ($event: any) => (_ctx.requestError = null))
      }, null, 8, ["message"]),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickLinkApi && _ctx.onClickLinkApi(...args)))
        }, "API連携する")
      ])
    ]),
    _: 1
  }))
}